<div class="loader-container" [ngClass]="{'color': style === 'color'}">
    <div class="loader"></div>
    <div class="loader-text">
        {{description}} <span class="dot">.</span><span class="dot">.</span><span class="dot">.</span>
    </div>
</div>